import { SELLER_TYPE } from 'domains/seller/constants/seller-constants'
import { InputSelectOptions } from 'components/molecules'
import { DROPOFF_LOCATION, SHIPPING_METHOD, STATUS } from 'domains/consignment-inbound-request/constants/consignment-inbound-request-constants'

export const consignmentInboundRequestTextInputFields = [
  {
    name        : 'code',
    label       : 'Code',
    placeholder : 'Search by Inbound Code'
  },
  {
    name        : 'seller_name',
    label       : 'Seller Name',
    placeholder : 'Search by Seller Name'
  },
  {
    name        : 'seller_code',
    label       : 'Seller Code',
    placeholder : 'Search by Seller Code'
  },
  {
    name        : 'seller_email',
    label       : 'Seller Email',
    placeholder : 'Search by Seller Email'
  },
  {
    name        : 'seller_phone',
    label       : 'Seller Mobile',
    placeholder : 'Search by Seller Mobile'
  },
  {
    name        : 'notes',
    label       : 'Notes',
    placeholder : 'Search by Notes'
  }
]

export const consignmentInboundRequestSelectInputFields = [
  {
    name     : 'shipping_method',
    label    : 'Shipping Method',
    children : <InputSelectOptions options={ SHIPPING_METHOD } />
  },
  {
    name     : 'dropoff_location_city',
    label    : 'Dropoff Location',
    children : (<>
      <option key='' value=''>Choose one</option>
      {
        Object.keys(DROPOFF_LOCATION).map((key) => {
          const option = DROPOFF_LOCATION[key]
          return (
            <option
              key={ `dropoff-location-option-${option.value}` }
              value={ option.value }
              className='text-capitalize'
            >
              { option.value }
            </option>
          )
        })
      }
    </>)
  },
  {
    name     : 'status',
    label    : 'Status',
    children : <InputSelectOptions options={ STATUS } />
  },
  {
    name     : 'seller_type',
    label    : 'Seller Type',
    children : <InputSelectOptions options={ SELLER_TYPE } />
  }
]

export const consignmentInboundRequestDateInputFields = [
  {
    name  : 'received_at',
    label : 'Received At'
  },
  {
    name  : 'scheduled_at',
    label : 'Scheduled At'
  }
]
